import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { BtnIcon } from '../../../../common/BtnIcon/BtnIcon.jsx';

const _AddToCartBlock = ({ substStore, labelsStore, isGroup }) => {
  const addLabel = isGroup ? labelsStore.addToCartGroup : labelsStore.addToCartProduct;

  return (
    <div className="my-cart__btn-fav-shell" onClick={() => substStore.addToCart()}>
      <BtnIcon />
      <span className="btn-label">{addLabel}</span>
    </div>
  );
};

_AddToCartBlock.propTypes = {
  substStore: propTypes.shape({
    addToCart: propTypes.func.isRequired
  }).isRequired,

  labelsStore: propTypes.shape({
    add_to_cart_group: propTypes.string.isRequired,
    add_to_cart_product: propTypes.string.isRequired
  }).isRequired,
  isGroup: propTypes.bool
};

_AddToCartBlock.defaultProps = {
  isGroup: false
};

export const AddToCartBlock = inject('labelsStore')(observer(_AddToCartBlock));
